import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="my-Money" link="http://mymoney-6061b.web.app" bg="mymoney.png" mdxType="ProjectCard">
  my-money is finance traker app built with react and Firebase.
    </ProjectCard>
    <ProjectCard title="Chat-app" link="https://agitated-liskov-abbb4d.netlify.app" bg="chat-app.png" mdxType="ProjectCard">
  A real-time chat-app built with react and react-chat-engine.
    </ProjectCard>
    <ProjectCard title="the-dojo" link="https://thedojosite-d6942.web.app" bg="the-dojo.png" mdxType="ProjectCard">
  The-dojo is project management app built with react and Firebase.
    </ProjectCard>
    <ProjectCard title="Cryptoverse" link="https://cryptoverseee-react.netlify.app" bg="cryptoverse.png" mdxType="ProjectCard">
  Cryptoverse provide info about crypto built with react, ant-design and
  chart-js.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      